const productCategory = [
    { id: 1, label: "Airbuds", value: "airbuds" },
    { id: 2, label: "Camera", value: "camera" },
    { id: 3, label: "Earphones", value: "earphones" },
    { id: 4, label: "Mobile", value: "mobile" },
    { id: 5, label: "Mouse", value: "mouse" },
    { id: 6, label: "Printer", value: "printer" },
    { id: 7, label: "Processor", value: "processor" },
    { id: 8, label: "Refrigerator", value: "refrigerator" },
    { id: 9, label: "Speakers", value: "speakers" },
    { id: 10, label: "Trimmers", value: "trimmers" },
    { id: 11, label: "Television", value: "television" },
    { id: 12, label: "Watches", value: "watches" },
    { id: 13, label: "Clothes", value: 'clothes' }



]

export default productCategory